import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { BienvenidaDefault } from "@pages/producto/credito_simple/expediente_bienvenida/BienvenidaDefault";

const SCREEN_BY_TYPE: Partial<Record<string, ComponentType>> = {};

export const BienvenidaExpediente = () => {
  const applicationType = useSelector((state: RootState) => state.register.application?.type);
  const Screen = (applicationType && SCREEN_BY_TYPE[applicationType]) || BienvenidaDefault;
  return <Screen />;
};
